/* DOMI SKIN - product card behaviour, every page. Loaded from
   snippets/domi-head.

   1. PLACE. Horizon prints custom blocks under the title, never inside the
      photo, so each card's BEST SELLER flag and + ADD notch are moved onto
      the photo tile (.card-gallery) once rendered. A MutationObserver
      repeats this for infinite scroll and for "Goes well with", which is
      fetched after load (scripts inside fetched HTML never run, which is
      why this lives here and not in the card snippets). A re-rendered card
      replaces its old copy rather than stacking a second one.

   2. ADD. One delegated click handler for every [data-domi-add] button
      (Horizon cards and the homepage grid): adds one unit, refreshes the
      cart drawer, opens it. Capture phase, so the card's own "open the
      product" click never sees a press on the notch.

   3. iPHONE TOOLBAR. Safari 26 on iPhone floats its address bar over the
      bottom of the screen and hides whatever fixed content sits under it,
      which cut the wallet buttons off the bottom of the cart drawer. Mark
      that browser so domi-cart.css can keep the drawer's last row clear of
      the bar. Other browsers are left alone. */
(function () {
  if (window.__domiCards) return;
  window.__domiCards = true;

  try {
    var ua = navigator.userAgent;
    if (/iP(hone|od)/.test(ua) && /Version\/(2[6-9]|[3-9]\d)\./.test(ua) && !/CriOS|FxiOS|EdgiOS/.test(ua)) {
      document.documentElement.classList.add('domi-ios-bar');
    }
  } catch (e) {}

  function place() {
    var els = document.querySelectorAll(
      'product-card .domi-flag:not([data-placed]), product-card .domi-cardadd:not([data-placed])'
    );
    Array.prototype.forEach.call(els, function (el) {
      var card = el.closest('product-card');
      var g = card && card.querySelector('.card-gallery');
      if (!g) return;
      var kind = el.classList.contains('domi-flag') ? 'domi-flag' : 'domi-cardadd';
      Array.prototype.forEach.call(g.querySelectorAll(':scope > .' + kind), function (old) {
        if (old !== el) old.remove();
      });
      el.setAttribute('data-placed', '');
      g.appendChild(el);
    });
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; place(); }, 0);
  }
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place);
  else place();

  function openDrawer() {
    var icon = document.querySelector('cart-icon');
    var btn = icon ? icon.closest('button') : null;
    if (btn) btn.click();
  }

  function swapDrawer(html) {
    if (!html) return;
    var host = document.getElementById('shopify-section-cart-drawer-section');
    if (!host) return;
    var fresh = new DOMParser().parseFromString(html, 'text/html')
      .getElementById('shopify-section-cart-drawer-section');
    if (fresh) host.replaceWith(fresh);
  }

  document.addEventListener('click', async function (e) {
    var btn = e.target.closest ? e.target.closest('[data-domi-add]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled) return;

    var id = btn.getAttribute('data-domi-add');
    var label = btn.getAttribute('data-label') || '+ Add';
    btn.disabled = true;
    btn.textContent = 'Adding…';

    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: ['cart-drawer-section'] })
      });
      if (!res.ok) throw new Error('add failed');
      var data = await res.json();
      if (data.sections) swapDrawer(data.sections['cart-drawer-section']);
      btn.setAttribute('data-state', 'added');
      btn.textContent = 'Added ✓';
      openDrawer();
    } catch (err) {
      btn.setAttribute('data-state', 'error');
      btn.textContent = 'Try again';
    }

    setTimeout(function () {
      btn.removeAttribute('data-state');
      btn.textContent = label;
      btn.disabled = false;
    }, 2200);
  }, true);
})();
